import styled from '@emotion/styled';
import { string, oneOfType, number, object } from 'prop-types';
import { layout, space as spacing, border } from 'styled-system';

const Stack = styled.div(
  ({
    theme,
    space,
    minWidth,
    maxWidth,
    alignItems,
    divider,
    direction = 'column',
  }) => ({
    display: 'flex',
    flexDirection: direction,
    justifyContent: 'flex-start',
    alignItems,
    minWidth,
    maxWidth,

    '> *': direction === 'row'
        ? {
            marginLeft: 0,
            marginRight: 0,
          }
        : {
            marginTop: 0,
            marginBottom: 0,
          },

    '>* + *': direction === 'row'
        ? {
            marginLeft: theme.space[space],
            borderLeft: theme.borders[divider],
          }
        : {
            marginTop: theme.space[space],
            borderTop: theme.borders[divider],
          },
  }),
  layout,
  spacing,
  border
);

Stack.propTypes = {
  space: oneOfType([string, number]),
  width: oneOfType([string, number, object]),
  minWidth: oneOfType([string, number]),
  maxWidth: oneOfType([string, number]),
};

export default Stack;
